// extracted by mini-css-extract-plugin
export var container = "_bx-0";
export var content = "_bx-3";
export var customerTitle = "_bx-4";
export var empty = "_bx-5";
export var gray = "_bx-6";
export var header = "_bx-7";
export var info = "_bx-8";
export var loading = "_bx-2";
export var loadingCard = "_bx-9";
export var oneLine = "_bx-a";
export var personName = "_bx-e";
export var pillContainer = "_bx-b";
export var selected = "_bx-1";
export var text = "_bx-c";
export var twoLines = "_bx-d";
export var unread = "_bx-f";
export var unreadIndicator = "_bx-g";